import "./StepIndicator.css";
import logo from "../../assets/bhumeet.svg";
import stepperBg from '../../assets/dspsignup/stepperbg.png';

const StepIndicator = ({ steps, currentStep, completedSteps }) => {
  const getStepIcon = (stepIndex) => {
    if (completedSteps.includes(stepIndex)) {
      return steps[stepIndex].completedIcon || steps[stepIndex].activeIcon;
    } else if (stepIndex === currentStep) {
      return steps[stepIndex].activeIcon;
    } else {
      return steps[stepIndex].inActiveIcon;
    }
  };

  return (
    <div 
      className="step-indicator-container" 
      style={{ backgroundImage: `url(${stepperBg})` }}
    >
      <div className="step-indicator-logo">
        <img src={logo} alt="BhuMeet Logo" width={140} />
      </div>
      <div className="step-indicator-steps">
        {steps.map((step, index) => {
          const isLastStep = index === steps.length - 1;
          return (
            <div key={index} className="step-item">
              <div className="step-item-content">
                <img 
                  src={getStepIcon(step.id)} 
                  alt="" 
                  width={40} 
                  height={40} 
                />
                <div className="step-texts">
                  <span className="step-title">{step?.title}</span>
                  <span className="step-description">{step?.description}</span>
                </div>
              </div>
              {!isLastStep && (
                <div className="step-connector" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;
